import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { UserPermissionsComponent } from '@components/ui-user-permissions/user-permissions';
import { SharedModule } from '@modules/shared.module';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UiNgLetModule,
        MatExpansionModule,
        MatProgressSpinnerModule,
    ],
    declarations: [
        UserPermissionsComponent,
    ],
    exports: [
        UserPermissionsComponent,
    ],
})
export class UserPermissionModule { }
